import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        // Azul-escuro da marca: em branco, sobre o fundo claro do app, o
        // retorno das ações passava despercebido. Erro fica vermelho — falha
        // não pode ter a mesma cara de confirmação.
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#08254c] group-[.toaster]:text-white group-[.toaster]:border-[#08254c] group-[.toaster]:shadow-lg",
          error: "group-[.toaster]:!bg-[#d4353c] group-[.toaster]:!border-[#d4353c]",
          description: "group-[.toast]:text-white/80",
          actionButton: "group-[.toast]:bg-[#ffc83d] group-[.toast]:text-[#08254c]",
          cancelButton: "group-[.toast]:bg-white/15 group-[.toast]:text-white",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
